export const sendRedrawEvent = target=>{
    const event = new Event('redraw');
    target.dispatchEvent(event);
}
export const sendRedrawSimpleEvent = target=>{
    const event = new Event('redrawSimple');
    target.dispatchEvent(event);
}
export const sendUnselectEvent = target=>{
    const event = new Event('unselect');
    target.dispatchEvent(event);
}
export const sendReselectEvent = target=>{
    const event = new Event('reselect');
    target.dispatchEvent(event);
}
